import localizations from './Localizations';

const store = {
  localization: localizations,
};

export default store;
